import { ApiClient, ApiSchema, NotFoundError } from "@/api/ApiClient";
import { GenericModelApi } from "./GenericModelApi";
import { PriceFormData } from "@/formTypes/PriceDataType";
import { getTenantId } from "@utils/Auth";
import { RootState, store } from "@/store";
import { FORMULA_PRICES_MANAGEMENT_CODE } from "@utils/Constants";

export type PriceDataType = Partial<ApiSchema["Price"]["type"] & PriceFormData>;
class Api extends GenericModelApi<"Price", PriceDataType> {

    async optionsList(filters: any = {}, labelGenerator?: (item: PriceDataType) => string, valueProp: keyof PriceDataType = "id"): Promise<Record<string, string>> {
        const state: RootState = store.getState();
        const pricemanaged = state.suscription.suscription?.pricemanaged
        if (pricemanaged == FORMULA_PRICES_MANAGEMENT_CODE) {
            const { items = [] } = await this.fetchAll(filters, "", 1000);

            return items.filter(i => !!i.id).reduce((a, v) => {
                let label = `${v[this.listPropLabel] || ''}`;
                if (labelGenerator) {
                    const generateLabel = labelGenerator(v);
                    label = generateLabel || label;
                }
                return {
                    ...a,
                    [`${v[valueProp]}`]: label
                }
            }, {}) as Record<string, string>;
        } else {
            return {
                "1": "Precio 1",
                "2": "Precio 2",
                "3": "Precio 3",
                "4": "Precio 4",
            }
        }
    }

    async getDefaultPrice(): Promise<PriceDataType | number> {
        const state: RootState = store.getState();
        const pricemanaged = state.suscription.suscription?.pricemanaged
        if (pricemanaged == FORMULA_PRICES_MANAGEMENT_CODE) {
            const tenantId = await getTenantId();
            const filterObject = {
                and: [
                    { owner: { eq: tenantId } },
                    { default: { eq: true } },
                ]
            };

            const { data, errors } = await ApiClient.models[this.modelName].list({
                filter: filterObject,
            });

            if (errors) {
                throw new NotFoundError(`Error al obtener los precio por defecto`, "API_ERROR", errors);
            }
            if (data.length > 0) {
                return data[0]
            }

            return {};
        } else {
            return 1
        }
    }

}

export const PriceApi = new Api("Price", "title")